export const SOURCING_STYLE_SHEET_API = "/api/sourcing_style_sheet";
export const lsStylesFilterValStr = "styles_table_filter_obj";
export const lsFabricTrimsFilterValStr = "fab_trims_table_filter_obj";
export const lsBuyingFilterValStr = "buying_table_filter_obj";

export const fabricStylesDashboardExportOptions = [
	{
		key: "STANDARD",
		name: "Standard",
		apiUrl: `${SOURCING_STYLE_SHEET_API}/download_styles`,
		fileName: "sourcing_style_sheet",
		usePythonApi: false,
	},
	{
		key: "GINESYS_FORMAT",
		name: "Ginesys Format",
		apiUrl: "/api/download_styles_ginesys_format",
		fileName: "sourcing_style_sheet_ginesys_format",
		usePythonApi: true,
	},
	{
		key: "WASHCARE_FORMAT",
		name: "Washcare Format",
		apiUrl: "/api/download_wash_care_format",
		fileName: "sourcing_style_sheet_washcare_format",
		usePythonApi: true,
	},
];
